export default function setupPorts (ports) {
  if (global.dataLayer) {
    ports.pushToDataLayer.subscribe((event) => {
      global.dataLayer.push(event)
    })
  }
}
